export function hasLabelTemplateToken(text: string): boolean {
    return typeof text === 'string' && text.includes('${label');
}
